import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';

export default class AuthenticatedTeamsShowProjectsShowProjectVersionsController extends Controller {}
